import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Nutridata() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Nutridata;